



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus} from 'lucide-react';


import Toggle from "../../UI/Toggle";
const WhatsIncludedAddMore=({index ,contentType,no,id,totalNumber,status,contentIcon,editable,onRemove,changetotalNumber,changeItemStatus,changeItemTitle})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
  const [totalNo, setTotalNo] = useState(totalNumber);
    const [areYouSure, setAreYouSure] = useState(false);
    const [isSelected, setIsSelected] = useState(status); 
    const [itemTitle, setItemTitle] = useState(contentType); 
    
     const [animate, setAnimate] = useState(false);
    
     useEffect(() => {
        // console.log(itemArr)
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    const RenderIcon = ({ componentString }) => {
      // Check the componentString to decide which icon to render
      if (componentString === 'BookOpenCheck') {
        return <BookOpenCheck color="#958FDA" size={32} />;
      } if (componentString === 'Video') {
        return <Video color="#958FDA" size={32} />;
      }if (componentString === 'MonitorPlay') {
        return <MonitorPlay color="#958FDA" size={32} />;
      }if (componentString === 'NotepadText') {
        return <NotepadText color="#958FDA" size={32} />;
      }if (componentString === 'TabletSmartphone') {
        return <TabletSmartphone color="#958FDA" size={32} />;
      }if (componentString === 'BookDown') {
        return <BookDown color="#958FDA" size={32} />;
      }if (componentString === 'GalleryHorizontal') {
        return <GalleryHorizontal color="#958FDA" size={32} />;
      }if (componentString === 'BookA') {
        return <BookA color="#958FDA" size={32} />;
      }if (componentString === 'BookOpenCheck') {
        return <BookOpenCheck color="#958FDA" size={32} />;
      }if (componentString === 'BadgePlus') {
        return <BadgePlus color="#958FDA" size={32} />;
      }
      // Add more cases if needed for other icons
    
      return null;
    };
     useEffect(()=>{
      setIsSelected(status)
     },[])
   return(<div style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.1)',
    opacity: animate ? 1 : 0,
    transition: `transform ${1+index}s ease, opacity ${1+index}s ease`,padding:"10px",margin:"10px",border:"2px dashed #958FDA ",borderRadius:"10px"}}> 
    {editable? <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",margin:"10px",
      background:"#958FDA"}} onClick={()=>{onRemove(id);}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>:""}
    
    {/* <span  style={{}}>Contact No :{index+1}</span>{areYouSure?
<div style={{}}><span  style={{}}>Are You Sure That You Want To Remove it? </span><div style={[{marginVertical:-15}]} >
              <div  onClick={()=>setAreYouSure(false)} style={{}} ><span  style={{color:'#ffffff',fontWeight:'600'}} >No</span></div>
              <div onClick={()=>{onRemove(id);setAreYouSure(false);}} style={{}}><span  style={{color:'#015E82',fontWeight:'600'}} >Yes , Remove it</span></div>
    
  </div></div>:''} */}
<div  style={{}}><div style={{}}>
    
    
    {/* <Phone style={{}} color="#015E82" size={18}/> */}
    
    
      {/*  <div onClick={()=>setAreYouSure(true)}  style={[]} ><X   color="#015E82" size={22}/></div> */}
    </div> 
    
    <div ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
        float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><RenderIcon componentString={contentIcon} /></div> 
        {editable?<input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  value={itemTitle} type="text"
        onChange={(e)=>{changeItemTitle(id,e.target.value);setItemTitle(e.target.value);}}
        style={{border:"2px dashed #958FDA ",borderRadius:"10px",outline:0,width:"90%",margin:"5px",
          padding:"10px",fontSize:"20px"}}></input>: <div style={{height:"50px",borderRadius:"5%",marginLeft:"10px",
            float:"left",alignContent:"center",textAlign:"center", textDecoration: 'none',
            position: 'relative',
            
            border: '0px',
            fontWeight: 'bold',
            background: 'linear-gradient(270deg, #E02CD3 20.56%, #6243EB 56.63%, #0952FF 69.98%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',}}>{contentType}</div>}
   <div style={{float:"right"}}>
   {/* <Toggle
      
      toggleState={(e)=>{setIsSelected(e) 
        changeItemStatus(id,e)}}
      
    />
     */}

<div  className="popup-input-card">
       
        <label onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   class="switchmute ">
 <input  id="togglemute" onChange={e=>{setIsSelected(previousState => !previousState) 
       setTimeout(()=>{changeItemStatus(id,!isSelected)},1000) }} checked={isSelected?"checked":""} type="checkbox"  
    /> 
  <span class="sliderlfmute round"></span>
</label>
    
    </div>

    </div> 
    {isSelected?<div style={{float:"right",}}><div style={{padding:"10px",}}>Total {contentType}...</div><div style={{gridTemplateColumns:  "15% 70% 15%" ,position:"relative"}}>
  <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)>0?parseInt(totalNo)-1:0)
    changetotalNumber(id,parseInt(totalNo)>0?parseInt(totalNo)-1:0);
  }} style={{float:"left",background:"#f1f1f1",width:"25px",height:"25px",borderRadius:"50%",marginRight:"10px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="#958FDA" size={22}/>
    <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  value={parseInt(totalNo)} type="number"
          onChange={(e)=>{changetotalNumber(id,e.target.value);setTotalNo(e.target.value);}}
          style={{border:"2px dashed #958FDA ",borderRadius:"10px",outline:0,width:"35%",float:"left",
            padding:"5px"}}
      /><Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)+1)
        changetotalNumber(id,parseInt(totalNo)+1);
      }}  style={{float:"left",background:"#f1f1f1",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"10px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="#958FDA" size={22}/></div>
    </div>:""}
    
    {/* <span  style={{}}> Visibility : </span>
    <Toggle
     
      onValueChange={(e)=>{onChangevisibilityNumber(id,!isEnabled);}}
      style={{}}
      
    /> */}
     
    </div>
    
    </div>
    
    </div>)
}  

export default WhatsIncludedAddMore;
